  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
//import TextField                                           from '@material-ui/core/TextField';
//import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
//import Dialog                                              from '@material-ui/core/Dialog';
//import DialogActions                                       from '@material-ui/core/DialogActions';
//import DialogContent                                       from '@material-ui/core/DialogContent';
//import DialogContentText                                   from '@material-ui/core/DialogContentText';
//import DialogTitle                                         from '@material-ui/core/DialogTitle';
//import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  //------
  // Style
  //------
  import HistoryDetailStyle                                  from "./HistoryDetailStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "HistoryDetail ";
//const Transition = React.forwardRef(function Transition(props, ref) {
//  return <Slide direction="up" ref={ref} {...props} />;
//});


class HistoryDetail extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      "cell_00_key"                                        : "",
      "cell_00_val"                                        : "",

      "cell_01_key"                                        : "",
      "cell_01_val"                                        : "",

      "cell_02_key"                                        : "",
      "cell_02_val"                                        : "",

      "cell_03_key"                                        : "",
      "cell_03_val"                                        : "",
      "cell_03_col"                                        : "",

      "cell_04_key"                                        : "",
      "cell_04_val"                                        : "",

      "cell_05_key"                                        : "",
      "cell_05_val"                                        : "",

      "cell_06_key"                                        : "",
      "cell_06_val"                                        : "",

      "cell_07_key"                                        : "",
      "cell_07_val"                                        : "",

      "cell_08_key"                                        : "",
      "cell_08_val"                                        : "",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                 = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                = this.dialog_handleClose.bind(this);
    this.startSpinners                                     = this.startSpinners.bind(this);
    this.stopSpinners                                      = this.stopSpinners.bind(this);

    //[goBack]
    this.goBack                                            = this.goBack.bind(this);

    this.makeScreenTranslations                            = this.makeScreenTranslations.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++++++
      //Login Screen
      //++++++++++++
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
      return;
    }

    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="HistoryDetail"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      })
      .catch(err => {
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCountries"        : res.countries });
        this.setState({ "parserObject_getCountries4Picker" : parserObject_getCountries4Picker });
      }catch(err){
        console.log('err='+err);
      }
    }
    this.makeScreenTranslations();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    let aRow = {};
    try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail")); }catch(err){;}

    let ws_mtcn          = "-";
    let ws_rcv_fname     = "-";
    let ws_rcv_lname     = "-";
    let ws_status        = "-";
    let ws_statusEl      = "-";
    let ws_statusEn      = "-";
    let ws_date          = "-";
    let ws_bankName      = "-";
    let ws_paymentMethod = "-";
    let ws_country       = "-";
    let ws_totalAmount   = 0.0;
    let ws_typeId        = 0;
    try {ws_mtcn          = aRow["mtcn"];          }catch(err){;}
    try {ws_rcv_fname     = aRow["rcv_fname"];     }catch(err){;}
    try {ws_rcv_lname     = aRow["rcv_lname"];     }catch(err){;}
    try {ws_status        = aRow["status"];        }catch(err){;}
    try {ws_statusEl      = aRow["statusEl"];      }catch(err){;}
    try {ws_statusEn      = aRow["statusEn"];      }catch(err){;}
    try {ws_date          = aRow["date"];          }catch(err){;}
    try {ws_bankName      = aRow["bankName"];      }catch(err){;}
    try {ws_paymentMethod = aRow["paymentMethod"]; }catch(err){;}
    try {ws_country       = aRow["country"];       }catch(err){;}
    try {ws_totalAmount   = aRow["totalAmount"];   }catch(err){;}
    try {ws_typeId        = aRow["typeId"];        }catch(err){;}
    if(ws_mtcn          === null || (typeof ws_mtcn          === "undefined")){ws_mtcn          = "-"; }
    if(ws_rcv_fname     === null || (typeof ws_rcv_fname     === "undefined")){ws_rcv_fname     = "-"; }
    if(ws_status        === null || (typeof ws_status        === "undefined")){ws_status        = "-"; }
    if(ws_statusEl      === null || (typeof ws_statusEl      === "undefined")){ws_statusEl      = "-"; }
    if(ws_statusEn      === null || (typeof ws_statusEn      === "undefined")){ws_statusEn      = "-"; }
    if(ws_date          === null || (typeof ws_date          === "undefined")){ws_date          = "-"; }
    if(ws_bankName      === null || (typeof ws_bankName      === "undefined")){ws_bankName      = "-"; }
    if(ws_paymentMethod === null || (typeof ws_paymentMethod === "undefined")){ws_paymentMethod = "-"; }
    if(ws_country       === null || (typeof ws_country       === "undefined")){ws_country       = "-"; }
    if(ws_totalAmount   === null || (typeof ws_totalAmount   === "undefined")){ws_totalAmount   = 0.0;}
    if(ws_typeId        === null || (typeof ws_typeId        === "undefined")){ws_typeId        = 0;  }

    //          if([[ws_status uppercaseString] isEqualToString:"PENDING"])  {cell.lb2.textColor = [UIColor orangeColor];}
    //     else if([[ws_status uppercaseString] isEqualToString:"COMPLETED"]){cell.lb2.textColor = [UIColor colorWithRed:53.0/255.0  green:182.0/255.0 blue:180.0/255.0 alpha:1.0]; }
    //     else if([[ws_status uppercaseString] isEqualToString:"CANCELED"]) {cell.lb2.textColor = [UIColor redColor];   }

    let cell_00_key = this.NSInforString("History2_key1");
    let cell_00_val = ws_rcv_fname + " " + wu_Utilities.addStars(ws_rcv_lname);

    let cell_01_key = this.NSInforString("History2_key2");
    let cell_01_val = ws_date;

    let cell_02_key = this.NSInforString("History2_key3");
    let cell_02_val = ws_mtcn;

    let cell_03_key = this.NSInforString("History2_key4");
    let cell_03_val = (localStorage.getItem("lang")==='el') ? ws_statusEl : ws_statusEn;
    let cell_03_col = "";
    if(ws_status === "COMPLETED"){ cell_03_col = "#35B6B4"; } //35B6B4 (green)
    if(ws_status === "CANCELED") { cell_03_col = "#F10D0D"; } //F10D0D (red)
    if(ws_status === "PENDING")  { cell_03_col = "#FF931E"; } //FF931E (orange)

    let cell_04_key = this.NSInforString("History2_key5");
  //let cell_04_val = (ws_paymentMethod === "OMT_BANK") ? "Bank Deposit" : "Credit/Debit Card";
    let cell_04_val = (ws_paymentMethod === "OMT_BANK") ? this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1") : this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1");

    let cell_05_key = this.NSInforString("History2_key5b");
  //let cell_05_val = (ws_typeId===21) ? "Bank Account" : "Cash in Minutes";
    let cell_05_val = (ws_typeId===21) ? this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1") : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1");

    let cell_06_key = this.NSInforString("History2_key6");
  //let cell_06_val = ws_totalAmount.toFixed(2)+"  EUR";
    let cell_06_val = this.comvert2ProperAmountFormat(ws_totalAmount.toFixed(2))+"  EUR";

    //let cell_08_key = this.NSInforString("History2_key7");
    //let cell_08_val = ws_bankName;

    let cell_07_key = this.NSInforString("History2_key8");
    let cell_07_val = ws_country!=="" ? wu_Utilities.findCountryNameFromCountryId(ws_country,localStorage.getItem("lang")) : "-";

    return (
      <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={6}>

          {api.backButtonAtHeader === true ? (
            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={11}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("History_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("History_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem>
            </GridContainer>
          )}

          <div style={{marginBottom:20}}>
            <List component="nav" aria-label="main mailbox folders">
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_00_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_00_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_01_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_01_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_02_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_02_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_03_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div style={{color:cell_03_col }} className={classes.cell_val}>{cell_03_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_04_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_04_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_05_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_05_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_06_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_06_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
              <ListItem>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_key}>{cell_07_key}</div></GridItem>
                  <GridItem xs={12} sm={12} md={12}><div className={classes.cell_val}>{cell_07_val}</div></GridItem>
                </GridContainer>
              </ListItem>
              <Divider />
            </List>
          </div>

          {/* -------------------------------------------------- */}
          {/* ----------[goBack Bottom]------------------------- */}
          {/* -------------------------------------------------- */}
          {api.backButtonAtBottom === true ? (
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={false}
                    className={classes.backButton}
                    color="rose"
                    onClick={this.goBack}>
                    {this.NSInforString("History3_btn_prev")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
          ) : ( "" ) }

        </GridItem>
      </GridContainer>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Make HTTP & Setup UI------------------------------
  //----------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      //let methName = filename+"makeScreenTranslations ";
      //if(api.print_logs){console.log(methName);}

      let aRow = {};
      try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail")); }catch(err){;}

      let ws_mtcn          = "-";
      let ws_rcv_fname     = "-";
      let ws_rcv_lname     = "-";
      let ws_status        = "-";
      let ws_statusEl      = "-";
      let ws_statusEn      = "-";
      let ws_date          = "-";
      let ws_bankName      = "-";
      let ws_paymentMethod = "-";
      let ws_country       = "-";
      let ws_totalAmount   = 0.0;
      let ws_typeId        = 0;
      try {ws_mtcn          = aRow["mtcn"];          }catch(err){;}
      try {ws_rcv_fname     = aRow["rcv_fname"];     }catch(err){;}
      try {ws_rcv_lname     = aRow["rcv_lname"];     }catch(err){;}
      try {ws_status        = aRow["status"];        }catch(err){;}
      try {ws_statusEl      = aRow["statusEl"];      }catch(err){;}
      try {ws_statusEn      = aRow["statusEn"];      }catch(err){;}
      try {ws_date          = aRow["date"];          }catch(err){;}
      try {ws_bankName      = aRow["bankName"];      }catch(err){;}
      try {ws_paymentMethod = aRow["paymentMethod"]; }catch(err){;}
      try {ws_country       = aRow["country"];       }catch(err){;}
      try {ws_totalAmount   = aRow["totalAmount"];   }catch(err){;}
      try {ws_typeId        = aRow["typeId"];        }catch(err){;}
      if(ws_mtcn          === null || (typeof ws_mtcn          === "undefined")){ws_mtcn          = "-"; }
      if(ws_rcv_fname     === null || (typeof ws_rcv_fname     === "undefined")){ws_rcv_fname     = "-"; }
      if(ws_status        === null || (typeof ws_status        === "undefined")){ws_status        = "-"; }
      if(ws_statusEl      === null || (typeof ws_statusEl      === "undefined")){ws_statusEl      = "-"; }
      if(ws_statusEn      === null || (typeof ws_statusEn      === "undefined")){ws_statusEn      = "-"; }
      if(ws_date          === null || (typeof ws_date          === "undefined")){ws_date          = "-"; }
      if(ws_bankName      === null || (typeof ws_bankName      === "undefined")){ws_bankName      = "-"; }
      if(ws_paymentMethod === null || (typeof ws_paymentMethod === "undefined")){ws_paymentMethod = "-"; }
      if(ws_country       === null || (typeof ws_country       === "undefined")){ws_country       = "-"; }
      if(ws_totalAmount   === null || (typeof ws_totalAmount   === "undefined")){ws_totalAmount   = 0.0;}
      if(ws_typeId        === null || (typeof ws_typeId        === "undefined")){ws_typeId        = 0;  }

      //          if([[ws_status uppercaseString] isEqualToString:"PENDING"])  {cell.lb2.textColor = [UIColor orangeColor];}
      //     else if([[ws_status uppercaseString] isEqualToString:"COMPLETED"]){cell.lb2.textColor = [UIColor colorWithRed:53.0/255.0  green:182.0/255.0 blue:180.0/255.0 alpha:1.0]; }
      //     else if([[ws_status uppercaseString] isEqualToString:"CANCELED"]) {cell.lb2.textColor = [UIColor redColor];   }

      this.setState({
        "cell_00_key" : this.NSInforString("History2_key1"),
        "cell_00_val" : ws_rcv_fname + " " + wu_Utilities.addStars(ws_rcv_lname),

        "cell_01_key" : this.NSInforString("History2_key2"),
        "cell_01_val" : ws_date,

        "cell_02_key" : this.NSInforString("History2_key3"),
        "cell_02_val" : ws_mtcn,

        "cell_03_key" : this.NSInforString("History2_key4"),
        "cell_03_val" : (localStorage.getItem("lang")==='el') ? ws_statusEl : ws_statusEn,
        "cell_03_col" : "",

        "cell_04_key" : this.NSInforString("History2_key5"),
        "cell_04_val" : (ws_paymentMethod === "OMT_BANK") ? "Bank Deposit" : "Credit/Debit Card",

        "cell_05_key" : this.NSInforString("History2_key5b"),
        "cell_05_val" : (ws_typeId===21) ? "Bank Account" : "Cash in Minutes",

        "cell_06_key" : this.NSInforString("History2_key6"),
      //"cell_06_val" : ws_totalAmount.toFixed(2)+"  EUR",
        "cell_06_val" : this.comvert2ProperAmountFormat(ws_totalAmount.toFixed(2))+"  EUR",

        "cell_08_key" : this.NSInforString("History2_key7"),
        "cell_08_val" : ws_bankName,

        "cell_07_key" : this.NSInforString("History2_key8"),
        "cell_07_val" : ws_country!=="" ? wu_Utilities.findCountryNameFromCountryId(ws_country,localStorage.getItem("lang")) : "-",
      });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
}
HistoryDetail.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(HistoryDetailStyle)(HistoryDetail)
);
